<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <h1 class="card-title ml-3">
            <strong>{{ title }}</strong>
          </h1>
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <!-- <p class="card-category ml-3">{{ description }}</p> -->
            </template>

            <div class="row">
              <div
                class="col-md-4 d-none d-sm-none d-xs-none d-md-none d-lg-block d-xl-block d-xxl-block"
              >
                <div class="input-group p-2 ml-md-4 mt-1">
                  <label>Filtrar por placa:</label>
                  <multiselect
                    v-model="id_vehicle"
                    label="plate"
                    :options="vehicleTmp"
                    track-by="id"
                    selectLabel="Click/enter para elegir"
                    selectedLabel="Seleccionado"
                    deselectLabel="Click/Enter para remover"
                    select-label="Seleccionar"
                    placeholder="Seleccione"
                  >
                  </multiselect>
                </div>
              </div>
              <div
                class="col-md-1 pt-md-2 mt-4 d-none d-sm-none d-xs-none d-md-none d-lg-block d-xl-block d-xxl-block"
              >
                <button
                  type="button"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Limpiar filtros"
                  :class="'btn btn-sm m-1 btn-fill   btn-info '"
                  @click.prevent="cleanFilters()"
                  style="
                    border-radius: 10px !important;
                    height: 40px;
                    right: 30px !important;
                  "
                >
                  <span style="color: white">
                    <v-icon name="trash" class="mx-1" fill="white"></v-icon>
                  </span>
                </button>
              </div>
              <div
                class="col-md-4 d-block d-sm-block d-xs-block d-md-block d-lg-none d-xl-none d-xxl-none"
              >
                <div class="input-group p-2" style="width: 200px">
                  <label>Filtrar por placa:</label>
                  <multiselect
                    v-model="id_vehicle"
                    label="plate"
                    :options="vehicleTmp"
                    track-by="id"
                    selectLabel="Click/enter para elegir"
                    selectedLabel="Seleccionado"
                    deselectLabel="Click/Enter para remover"
                    select-label="Seleccionar"
                    placeholder="Seleccione"
                  >
                  </multiselect>

                  <button
                    type="button"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Limpiar filtros"
                    :class="'btn btn-sm m-1 btn-fill float-right  btn-info '"
                    @click.prevent="cleanFilters()"
                    style="
                      border-radius: 10px !important;
                      height: 40px;
                      left: 100% !important;
                      position: relative;
                      top: -45px;
                    "
                  >
                    <span style="color: white">
                      <v-icon name="trash" class="mx-1" fill="white"></v-icon>
                    </span>
                  </button>
                </div>
              </div>

              <div class="col-md-7 mt-4">
                <button
                  type="button"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Crear nuevo"
                  :class="'btn btn-fill float-right m-1 btn-info'"
                  @click.prevent="goNew()"
                  style="
                    border-radius: 25px !important;
                    background: #651366 !important;
                  "
                >
                  <span style="color: white; font-size: 14px">
                    <strong>{{ buttonNewLabel }}</strong></span
                  >
                </button>
              </div>

              <br />
            </div>

            <div
              class="h-100 mt-4"
              style="border-color: none !important; overflow: hidden !important"
            >
              <div
                class="col-12 mb-3"
                v-for="(item, index) in UsersTmp"
                :key="index"
                :metaInfo="metaInfo"
                @click.prevent="goView(item.id)"
                style="cursor: pointer"
              >
                <div
                  class="card-body justify-content-center d-flex"
                  style="
                    background-color: #f8f8f8;
                    border-radius: 20px !important;
                    box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.5);
                  "
                >
                  <div
                    class="row justify-content-center justify-content-sm-start col-12"
                  >
                    <div class="col-sm-2">
                      <img
                        v-if="
                          item.vehicle.url_image != null &&
                          item.vehicle.url_image != undefined &&
                          item.vehicle.url_image != '' &&
                          item.vehicle.url_image != 'prueba'
                        "
                        class="img-fluid mx-auto d-block mt-2"
                        :src="item.vehicle.url_image"
                        onerror="this.onerror=null;src=this.default_img"
                        style="
                          text-align: center;
                          border-radius: 10px;
                          height: 100px;
                        "
                      />
                      <img
                        v-else
                        class="img-fluid mx-auto d-block mt-2"
                        src="https://play-lh.googleusercontent.com/Fa-hPHOekHE_3QxlVqjlnz1SCnwEye8BAVsqcHX4tzFTdiY9hM6U1FO1hc1YyTYWh0o=s200"
                        style="
                          text-align: center;
                          border-radius: 10px;
                          height: 120px;
                        "
                      />
                    </div>
                    <div
                      class="col-sm-2 text-center text-sm-start px-2 mt-3"
                    >
                      <h5
                        class="card-title"
                        style="font-size: 17px; color: black !important"
                      >
                        <strong>Color: {{ item.vehicle.color }}</strong>
                      </h5>
                      <h5
                        class="card-title"
                        style="font-size: 17px; color: black !important"
                      >
                        <strong>Modelo: {{ item.vehicle.name }}</strong>
                      </h5>
                      <h5
                        class="card-title"
                        style="font-size: 17px; color: black !important"
                      >
                        <strong>Año: {{ item.vehicle.year }}</strong>
                      </h5>
                      <h5
                        class="card-title"
                        style="font-size: 17px; color: black !important"
                      >
                        <strong>Placa: {{ item.vehicle.plate }}</strong>
                      </h5>
                    </div>

                    <div class="col-sm-1 mt-3 px-0">
                      <img
                        v-if="
                          item.user.url_image != null &&
                          item.user.url_image != undefined &&
                          item.user.url_image != '' &&
                          item.user.url_image != 'prueba'
                        "
                        class="img-fluid mx-auto d-block mt-2"
                        :src="item.user.url_image"
                        style="
                          height: 80px;
                          width: 80px;
                          text-align: center;
                          border-radius: 50px;
                        "
                      />
                      <img
                        v-else
                        class="img-fluid mx-auto d-block mt-2"
                        src="https://static.vecteezy.com/system/resources/thumbnails/008/442/086/small_2x/illustration-of-human-icon-user-symbol-icon-modern-design-on-blank-background-free-vector.jpg"
                        onerror="this.onerror=null;src=this.default_img"
                        style="
                          height: 80px;
                          width: 80px;
                          text-align: center;
                          border-radius: 50px;
                        "
                      />
                    </div>
                    <div
                      class="col-sm-3 align-items-center row text-center text-sm-start"
                    >
                      <div>
                        <h5 style="color: black !important">
                          <strong
                            >{{ item.user.first_name }}
                            {{ item.user.last_name }}</strong
                          >
                        </h5>
                        <p style="color: black !important; font-size: 16px">
                          {{ formatDate(item.date) }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="col-sm-2 align-items-center d-flex justify-content-center"
                    >
                      <div class="row">
                        <button
                          v-if="item.id_type_inspection_status == 3"
                          type="button"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Crear nuevo"
                          :class="'btn btn-fill  btn-info'"
                          @click.prevent="goView(item.id)"
                          style="
                            border-radius: 25px !important;
                            background: #8cc540 !important;
                          "
                        >
                          <span style="color: white; font-size: 14px">
                            <strong>Aprobado</strong></span
                          >
                        </button>
                        <button
                          v-if="item.id_type_inspection_status == 1"
                          type="button"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Crear nuevo"
                          :class="'btn btn-fill  btn-info'"
                          @click.prevent="goView(item.id)"
                          style="
                            border-radius: 25px !important;
                            background: #f0c505 !important;
                          "
                        >
                          <span style="color: white; font-size: 14px">
                            <strong>En proceso</strong></span
                          >
                        </button>
                        <button
                          v-if="item.id_type_inspection_status == 2"
                          type="button"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Crear nuevo"
                          :class="'btn btn-fill  btn-info'"
                          @click.prevent="goView(item.id)"
                          style="
                            border-radius: 25px !important;
                            background: #bf1d1d !important;
                          "
                        >
                          <span style="color: white; font-size: 14px">
                            <strong>Negada</strong></span
                          >
                        </button>
                      </div>
                    </div>
                    <div
                      class="col-sm-2 align-items-center d-flex justify"
                    >
                      <div class="row">
                        <div class="col-md-12">
                          <p style="font-size: 11px">
                            Resultado final: {{ item.total_result }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row justify-content-center">
                <div class="col">
                  <ul class="pagination justify-content-center">
                    <li
                      class="page-item"
                      :class="{ disabled: metaInfo.current_page === 1 }"
                      @click="changePage('minus')"
                    >
                      <a class="page-link" aria-label="Previous" role="button">
                        <span aria-hidden="true">&laquo;</span>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{
                        active: metaInfo.current_page === metaInfo.first_page,
                      }"
                      @click="changePageByNumber(metaInfo.current_page)"
                    >
                      <a
                        style="background: orange !important; color: white"
                        class="page-link"
                        >{{ metaInfo.current_page }}</a
                      >
                    </li>
                    <!-- <li class="page-item" v-if="metaInfo.current_page > metaInfo.first_page + 2">
        <a class="page-link">...</a>
      </li> -->
                    <template v-for="pageNumber in displayedPages">
                      <li
                        class="page-item"
                        :class="{
                          active: pageNumber === metaInfo.current_page,
                        }"
                        @click="changePageByNumber(pageNumber)"
                      >
                        <a class="page-link">{{ pageNumber }}</a>
                      </li>
                    </template>
                    <!-- <li class="page-item" v-if="metaInfo.last_page - metaInfo.current_page > 1">
        <a class="page-link">...</a>
      </li> -->
                    <!-- <li class="page-item"  :class="{ 'active': metaInfo.current_page === metaInfo.last_page }"
        @click="changePageByNumber(metaInfo.last_page)">
        <a  style="background: orange !important; color: white;" class="page-link">{{ metaInfo.last_page }}</a>
      </li> -->
                    <li
                      class="page-item"
                      :class="{
                        disabled: metaInfo.current_page === metaInfo.last_page,
                      }"
                      @click="changePage('plus')"
                    >
                      <a class="page-link" aria-label="Next" role="button">
                        <span aria-hidden="true">&raquo;</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
    <link
      href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
      rel="stylesheet"
      integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
      crossorigin="anonymous"
    />
  </div>
</template>
<script>
function clearAccents(cadena) {
  let chars = {
    á: "a",
    é: "e",
    í: "i",
    ó: "o",
    ú: "u",
    à: "a",
    è: "e",
    ì: "i",
    ò: "o",
    ù: "u",
    ñ: "n",
    Á: "A",
    É: "E",
    Í: "I",
    Ó: "O",
    Ú: "U",
    À: "A",
    È: "E",
    Ì: "I",
    Ò: "O",
    Ù: "U",
    Ñ: "N",
  };
  let expr = /[áàéèíìóòúùñ]/gi;
  let res = cadena.replace(expr, function (e) {
    return chars[e];
  });
  return res;
}

import { mapState } from "vuex";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";
import LTable from "src/components/Table.vue";
import Card from "src/components/Cards/Card.vue";
import Multiselect from "vue-multiselect";
import moment from "moment";
import Cookies from "js-cookie";

import { all } from "axios";

export default {
  components: {
    LTable,
    Card,
    Multiselect,
  },
  data() {
    return {
      //LABELS
      title: "Mis inspecciones",
      description: "Podrás gestionar a los administradores de la plataforma",
      buttonNewLabel: "Crear nueva inspección",
      buttonNewUrl: "InspectionsNew",
      buttonEditUrl: "InspectionsEdit",
      finderLabel: "Placa del vehiculo",
      //VARIABLE
      finder: "",
      metaInfo: {},
      sortOrder: "asc",
      // sortKey: "first_name",
      default_img: "public/img/logochami.png",
      //FILTERS
      active_model: "",
      id_vehicle: "",
      vehicleTmp: [],
      activeTmp: [
        {
          id: 1,
          name: "Activo",
        },
        {
          id: 0,
          name: "Inactivo",
        },
      ],

      //TABLE DATA
      tableData: {
        columns: [
          {
            name: "Nombre",
            key: "name",
          },
          {
            name: "Apellido",
            key: "last_name",
          },
          {
            name: "Cédula",
            key: "dni",
          },
          {
            name: "Correo",
            key: "email",
          },
          {
            name: "Teléfono celular",
            key: "phone_1",
          },
          {
            name: "Fecha inscripción",
            key: "created_at",
          },

          {
            name: "Acciones",
            key: "actions",
          },
        ],
        data: [],
      },
      //DATA Variables
      Users: [],
      UsersTmp: [],

      //TABLE Buttons
      buttons: [
        {
          icon: "eye",
          icon_negative: "eye",
          type_button: "btn-info",
          tooltip: "Ver Detalles",
          url: "/admin/users/admins/edit",
          type_action: "go_url",
          action: "go_url",
          fill_icon: "#f76e2a",
          background_color: "white",
        },
        {
          icon: "check-square",
          icon_negative: "minus-square",
          type_button: "btn-warning",
          tooltip: "Cambiar Estatus",
          url: "",
          type_action: "go_method",
          action: "changeStatus",
          fill_icon: "#651366",
          background_color: "white",
        },
        {
          icon: "trash",
          icon_negative: "trash",
          type_button: "btn-danger",
          tooltip: "Eliminar administrador",
          url: "",
          type_action: "go_method",
          action: "rejectedStatus",
          fill_icon: "#8CC540",
          background_color: "white",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.auth.me,
      me_rol: (state) => state.auth.me_rol,
    }),
    sortOptions() {
      return [];
    },
    // rows() {
    //   return this.UsersTmp.length;
    // },
    displayedPages() {
      const currentPage = this.metaInfo.current_page;
      const lastPage = this.metaInfo.last_page;
      const range = 2; // Número de páginas a mostrar a cada lado de la página actual

      const startPage = Math.max(
        currentPage - range,
        this.metaInfo.first_page + 1
      );
      const endPage = Math.min(currentPage + range, lastPage - 1);
      const pages = [];

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      return pages;
    },
  },
  mounted() {
    this.loadElements();
    this.loadVehicle();
  },
  updated() {
    console.log(this.user);
  },
  watch: {
    id_vehicle(newVal, oldVal) {
      if (newVal !== oldVal) {
        console.log(this.id_vehicle);
        this.loadElements();
      }
    },
  },
  methods: {
    ...mapActions(["getData", "changeStatusData", "updateData"]),
    goNew() {
      this.$router.push({ name: this.buttonNewUrl });
    },
    goView(item) {
      this.$router.push({ path: "/admin/inspections/review/" + item });
    },
    cleanFilters() {
      this.finder = "";
      this.active_model = "";
      this.loadElements();
      this.id_vehicle = "";
    },

    // formatDate(date) {
    //   return moment(date).format("DD/MM/YYYY");
    // },
    formatDate(date) {
      return moment(date).format("DD [de ]MMMM [de] YYYY"); // Ejemplo: 27 de Mayo de 2024
    },
    changePageByNumber(page) {
      this.metaInfo.current_page = page;
      this.loadElements();
    },
    changePage(type) {
      if (type == "plus") {
        if (this.metaInfo.current_page < this.metaInfo.last_page) {
          this.metaInfo.current_page += 1;
        }
        this.loadElements();
      } else {
        if (this.metaInfo.current_page > this.metaInfo.first_page) {
          this.metaInfo.current_page -= 1;
        }
        this.loadElements();
      }
    },
    loadVehicle() {
      let form = {
        url: "vehicle/all",
      };
      this.isBusy = true;

      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.vehicleTmp = response.data;
            console.log(this.vehicleTmp, "vehiculos");
            this.loadElements();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadElements() {
      let form = {
        url: "inspection/all",
        params: {
          active: this.active_model ? this.active_model.id : null,
          // order_key: this.sortKey,
          // order_value: this.sortOrder,
          // Cookies.set("is_inspector", is_inspector, { expires: expires_at_date })
          id_user_inspector: Cookies.get("id"),
          order_key: "id",
          order_value: "desc",
          active: 1,
          page: 1,
          limit: 10,
        },
      };

      if (this.finder != "") {
        console.log("Searching:" + this.finder);
        form.params.query = this.finder;
      }
      if (this.metaInfo.current_page > 1) {
        form.params.page = this.metaInfo.current_page;
      }
      if (this.id_vehicle) {
        console.log("que esta llegando aqui:" + this.id_vehicle.id);

        form.params.id_vehicle = this.id_vehicle.id; // Aquí cambiamos a enviar solo el ID
      }
      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          response.data.data.forEach((element) => {
            element.created_at = this.formatDate(element.created_at);
            element.birthdate = this.formatDate(element.birthdate);
          });
          this.isBusy = false;
          if (response.code === 200) {
            this.Users = response.data.data;
            this.metaInfo = response.data.meta;
            this.UsersTmp = this.Users;

            console.log(this.UsersTmp, "Aqui estan los datos");
            console.log(this.UsersTmp.id, "id del edit");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    searchNested(object, query, fields) {
      for (let field of fields) {
        let fieldParts = field.split(".");
        let value = object;
        for (let part of fieldParts) {
          if (value[part] !== undefined) {
            value = value[part];
          } else {
            value = null;
            break;
          }
        }
        if (value && value.toLowerCase().includes(query.toLowerCase())) {
          return true;
        }
      }
      return false;
    },

    search(object, query, fields) {
      if (typeof object === "object" && object !== null) {
        for (let key in object) {
          if (object.hasOwnProperty(key)) {
            const fieldValue = object[key];

            // If the current key is an object, recursively search its fields
            if (typeof fieldValue === "object" && fieldValue !== null) {
              if (this.search(fieldValue, query, fields)) {
                return true;
              }
            } else if (
              // Check if the current key is included in the fields array, or if the key includes a field in the array
              fields.includes(key) ||
              fields.some((field) => key.includes(`${field}.`))
            ) {
              if (
                typeof fieldValue !== "object" &&
                typeof fieldValue !== "function" &&
                fieldValue !== null &&
                fieldValue
                  .toString()
                  .toLowerCase()
                  .includes(query.toLowerCase())
              ) {
                return true;
              } else if (
                typeof fieldValue === "object" &&
                fieldValue !== null
              ) {
                // If the field is an object, recursively search its fields
                if (this.search(fieldValue, query, fields)) {
                  return true;
                }
              }
            }
          }
        }
      }

      return false;
    },
    changeStatus(data) {
      let active = data.active === 1 ? 0 : 1;
      let title = data.active === 1 ? "Desactivar" : "Activar";
      let title2 = data.active === 1 ? "Desactivado" : "Activado";
      let text =
        data.active === 1
          ? "¿Estás seguro de desactivarlo ahora?"
          : "¿Estás seguro de activarlo ahora?";
      Swal.fire({
        title: title,
        text: text,
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#651366",
        cancelButtonColor: "#F76E2A",
        confirmButtonText: "Cambiar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let form = {
            id: data.id,
            url: "user/change_status",
            status: active,
          };
          this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadElements();
                data.active = active;
                Swal.fire({
                  title: title2,
                  icon: "success",
                  confirmButtonColor: "#651366",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },

    rejectedStatus(data) {
      let title = "Eliminar administrador";

      let text = "¿Estás seguro de eliminar este administrador?";
      Swal.fire({
        title: title,
        text: text,
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#651366",
        cancelButtonColor: "#F76E2A",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let form = {
            id: data.id,
            url: "user/change_status",
            status: 2,
          };
          this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadElements();
                // data.active = active;
                Swal.fire({
                  title: "El administrador fue eliminado",
                  icon: "success",
                });
                // location.reload();
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
  },
};
</script>

<style>
.page-item.active.page-link {
  background-color: orange;
  color: white;
}

/* Estilo para el botón siguiente cuando no está deshabilitado */
.page-item:not(.disabled).page-link:hover,
.page-item:not(.disabled).page-link:focus {
  color: orange !important;
  cursor: pointer;
}

/* Estilo para las flechas de navegación */
.pagination.page-item:first-child.page-link::before,
.pagination.page-item:last-child.page-link::after {
  content: "";
  display: inline-block;
  vertical-align: text-top;
}

.pagination.page-item:first-child.page-link::before {
  border-start: double 2px black;
  margin-right: 5px;
}

.pagination.page-item:last-child.page-link::after {
  border-end: double 2px black;
  margin-left: 5px;
}
</style>
